module.exports = __webpack_public_path__ + "img/vip_shangshengwhite_icon.68abdff6.png";